{
  "actionButtons": {
    "deselectAll": "deselectAll",
    "export": "export",
    "exportAsCsv": "exportAsCsv",
    "exportAsPdf": "exportAsPdf",
    "selectAll": "selectAll"
  },
  "areYouSureModal": {
    "cancelText": "cancelText",
    "confirmText": "confirmText",
    "title": "title"
  },
  "columnManager": {
    "columns": "columns",
    "hiddenColumns": "hiddenColumns",
    "noColumnsMatch": "noColumnsMatch",
    "pinnedColumns": "pinnedColumns",
    "searchPlaceholder": "Buscar colunas...",
    "visibleColumns": "visibleColumns"
  },
  "coordinates": {
    "latitude": "latitude",
    "latitudePlaceholder": "latitudePlaceholder",
    "latitudeTooltip": "latitudeTooltip",
    "longitude": "longitude",
    "longitudePlaceholder": "longitudePlaceholder",
    "longitudeTooltip": "longitudeTooltip"
  },
  "copy": "{{text}} copiado para a área de transferência",
  "countries": {
    "AC": "Ilha de Ascensão",
    "AD": "Andorra",
    "AE": "Emirados Árabes Unidos",
    "AF": "Afeganistão",
    "AG": "Antígua e Barbuda",
    "AI": "Anguilla",
    "AL": "Albânia",
    "AM": "Armênia",
    "AO": "Angola",
    "AQ": "Antártida",
    "AR": "Argentina",
    "AS": "Samoa Americana",
    "AT": "Áustria",
    "AU": "Austrália",
    "AW": "Aruba",
    "AX": "Ilhas Åland",
    "AZ": "Azerbaijão",
    "BA": "Bósnia e Herzegovina",
    "BB": "Barbados",
    "BD": "Bangladesh",
    "BE": "Bélgica",
    "BF": "Burquina Faso",
    "BG": "Bulgária",
    "BH": "Bahrein",
    "BI": "Burundi",
    "BJ": "Benin",
    "BL": "São Bartolomeu",
    "BM": "Bermudas",
    "BN": "Brunei",
    "BO": "Bolívia",
    "BQ": "Países Baixos Caribenhos",
    "BR": "Brasil",
    "BS": "Bahamas",
    "BT": "Butão",
    "BV": "Ilha Bouvet",
    "BW": "Botsuana",
    "BY": "Bielorrússia",
    "BZ": "Belize",
    "CA": "Canadá",
    "CC": "Ilhas Cocos (Keeling)",
    "CD": "Congo-Kinshasa",
    "CF": "República Centro-Africana",
    "CG": "Congo-Brazzaville",
    "CH": "Suíça",
    "CI": "Costa do Marfim",
    "CK": "Ilhas Cook",
    "CL": "Chile",
    "CM": "Camarões",
    "CN": "China",
    "CO": "Colômbia",
    "CP": "Ilha Clipperton",
    "CR": "Costa Rica",
    "CU": "Cuba",
    "CV": "Cabo Verde",
    "CW": "Curaçao",
    "CX": "Ilha Christmas",
    "CY": "Chipre",
    "CZ": "República Tcheca",
    "DE": "Alemanha",
    "DG": "Diego Garcia",
    "DJ": "Djibuti",
    "DK": "Dinamarca",
    "DM": "Dominica",
    "DO": "República Dominicana",
    "DZ": "Argélia",
    "EA": "Ceuta e Melilla",
    "EC": "Equador",
    "EE": "Estônia",
    "EG": "Egito",
    "EH": "Saara Ocidental",
    "ER": "Eritreia",
    "ES": "Espanha",
    "ET": "Etiópia",
    "EU": "União Europeia",
    "FI": "Finlândia",
    "FJ": "Fiji",
    "FK": "Ilhas Malvinas",
    "FM": "Micronésia",
    "FO": "Ilhas Faroé",
    "FR": "França",
    "GA": "Gabão",
    "GB": "Reino Unido",
    "GD": "Granada",
    "GE": "Geórgia",
    "GF": "Guiana Francesa",
    "GG": "Guernsey",
    "GH": "Gana",
    "GI": "Gibraltar",
    "GL": "Groenlândia",
    "GM": "Gâmbia",
    "GN": "Guiné",
    "GP": "Guadalupe",
    "GQ": "Guiné Equatorial",
    "GR": "Grécia",
    "GS": "Geórgia do Sul e Ilhas Sandwich do Sul",
    "GT": "Guatemala",
    "GU": "Guam",
    "GW": "Guiné-Bissau",
    "GY": "Guiana",
    "HK": "Região Administrativa Especial de Hong Kong",
    "HM": "Ilhas Heard e McDonald",
    "HN": "Honduras",
    "HR": "Croácia",
    "HT": "Haiti",
    "HU": "Hungria",
    "IC": "Ilhas Canárias",
    "ID": "Indonésia",
    "IE": "Irlanda",
    "IL": "Israel",
    "IM": "Ilha de Man",
    "IN": "Índia",
    "IO": "Território Britânico do Oceano Índico",
    "IQ": "Iraque",
    "IR": "Irã",
    "IS": "Islândia",
    "IT": "Itália",
    "JE": "Jersey",
    "JM": "Jamaica",
    "JO": "Jordânia",
    "JP": "Japão",
    "KE": "Quênia",
    "KG": "Quirguistão",
    "KH": "Camboja",
    "KI": "Kiribati",
    "KM": "Comores",
    "KN": "São Cristóvão e Nevis",
    "KP": "Coreia do Norte",
    "KR": "Coreia do Sul",
    "KW": "Kuwait",
    "KY": "Ilhas Cayman",
    "KZ": "Cazaquistão",
    "LA": "Laos",
    "LB": "Líbano",
    "LC": "Santa Lúcia",
    "LI": "Liechtenstein",
    "LK": "Sri Lanka",
    "LR": "Libéria",
    "LS": "Lesoto",
    "LT": "Lituânia",
    "LU": "Luxemburgo",
    "LV": "Letônia",
    "LY": "Líbia",
    "MA": "Marrocos",
    "MC": "Mônaco",
    "MD": "Moldávia",
    "ME": "Montenegro",
    "MF": "São Martinho",
    "MG": "Madagascar",
    "MH": "Ilhas Marshall",
    "MK": "Macedônia do Norte",
    "ML": "Mali",
    "MM": "Mianmar (Birmânia)",
    "MN": "Mongólia",
    "MO": "Região Administrativa Especial de Macau",
    "MP": "Ilhas Marianas do Norte",
    "MQ": "Martinica",
    "MR": "Mauritânia",
    "MS": "Montserrat",
    "MT": "Malta",
    "MU": "Maurício",
    "MV": "Maldivas",
    "MW": "Malawi",
    "MX": "México",
    "MY": "Malásia",
    "MZ": "Moçambique",
    "NA": "Namíbia",
    "NC": "Nova Caledônia",
    "NE": "Níger",
    "NF": "Ilha Norfolk",
    "NG": "Nigéria",
    "NI": "Nicarágua",
    "NL": "Países Baixos",
    "NO": "Noruega",
    "NP": "Nepal",
    "NR": "Nauru",
    "NU": "Niue",
    "NZ": "Nova Zelândia",
    "OM": "Omã",
    "PA": "Panamá",
    "PE": "Peru",
    "PF": "Polinésia Francesa",
    "PG": "Papua-Nova Guiné",
    "PH": "Filipinas",
    "PK": "Paquistão",
    "PL": "Polônia",
    "PM": "Saint Pierre e Miquelon",
    "PN": "Ilhas Pitcairn",
    "PR": "Porto Rico",
    "PS": "Territórios Palestinos",
    "PT": "Portugal",
    "PW": "Palau",
    "PY": "Paraguai",
    "QA": "Catar",
    "RE": "Reunião",
    "RO": "Romênia",
    "RS": "Sérvia",
    "RU": "Rússia",
    "RW": "Ruanda",
    "SA": "Arábia Saudita",
    "SB": "Ilhas Salomão",
    "SC": "Seicheles",
    "SD": "Sudão",
    "SE": "Suécia",
    "SG": "Singapura",
    "SH": "Santa Helena",
    "SI": "Eslovênia",
    "SJ": "Svalbard e Jan Mayen",
    "SK": "Eslováquia",
    "SL": "Serra Leoa",
    "SM": "San Marino",
    "SN": "Senegal",
    "SO": "Somália",
    "SR": "Suriname",
    "SS": "Sudão do Sul",
    "ST": "São Tomé e Príncipe",
    "SV": "El Salvador",
    "SX": "São Martinho (parte holandesa)",
    "SY": "Síria",
    "SZ": "Eswatini",
    "TA": "Tristão da Cunha",
    "TC": "Ilhas Turks e Caicos",
    "TD": "Chade",
    "TF": "Terras Austrais e Antárticas Francesas",
    "TG": "Togo",
    "TH": "Tailândia",
    "TJ": "Tajiquistão",
    "TK": "Tokelau",
    "TL": "Timor-Leste",
    "TM": "Turcomenistão",
    "TN": "Tunísia",
    "TO": "Tonga",
    "TR": "Turquia",
    "TT": "Trinidad e Tobago",
    "TV": "Tuvalu",
    "TW": "Taiwan",
    "TZ": "Tanzânia",
    "UA": "Ucrânia",
    "UG": "Uganda",
    "UM": "Ilhas Menores Distantes dos Estados Unidos",
    "UN": "Desconhecido",
    "US": "Estados Unidos",
    "UY": "Uruguai",
    "UZ": "Uzbequistão",
    "VA": "Vaticano",
    "VC": "São Vicente e Granadinas",
    "VE": "Venezuela",
    "VG": "Ilhas Virgens Britânicas",
    "VI": "Ilhas Virgens Americanas",
    "VN": "Vietnã",
    "VU": "Vanuatu",
    "WF": "Wallis e Futuna",
    "WS": "Samoa",
    "XK": "Kosovo",
    "YE": "Iêmen",
    "YT": "Mayotte",
    "ZA": "África do Sul",
    "ZM": "Zâmbia",
    "ZW": "Zimbábue"
  },
  "countriesEcobalyse": {
    "BD": "BD",
    "CN": "CN",
    "FR": "FR",
    "IN": "IN",
    "KH": "KH",
    "MA": "MA",
    "MM": "MM",
    "PK": "PK",
    "RAF": "RAF",
    "RAS": "RAS",
    "REE": "REE",
    "REO": "REO",
    "RLA": "RLA",
    "RME": "RME",
    "RNA": "RNA",
    "ROC": "ROC",
    "TN": "TN",
    "TR": "TR",
    "VN": "VN"
  },
  "dataLoad": {
    "error": {
      "message": "Não foi possível obter os dados solicitados. Por favor, recarregue a página",
      "title": "Ocorreu um erro"
    },
    "noResults": {
      "message": "Não encontramos nenhum dado relacionado à sua empresa. Por favor, tente novamente mais tarde.",
      "title": "Nenhum resultado"
    }
  },
  "documentUpload": {
    "helptext": "Tamanho máximo: {{ maxSize }}MB",
    "missingDocument": "missingDocument",
    "title": "Arraste e solte seus arquivos aqui ou clique para selecioná-los manualmente",
    "uploadSuppliers": "uploadSuppliers"
  },
  "error": {
    "default": "Ocorreu um erro",
    "message": "message",
    "title": "title"
  },
  "fabricProcess": {
    "knitting-circular": "knitting-circular",
    "knitting-fully-fashioned": "knitting-fully-fashioned",
    "knitting-integral": "knitting-integral",
    "knitting-mix": "knitting-mix",
    "knitting-straight": "knitting-straight",
    "weaving": "weaving"
  },
  "filter": "filter",
  "form": {
    "reset": "reset",
    "save": "save"
  },
  "languages": {
    "arabic": "arabic",
    "belarusian": "belarusian",
    "chinese": "Chinês",
    "dutch": "Holandês",
    "english": "Inglês",
    "french": "Francês",
    "german": "Alemão",
    "italian": "Italiano",
    "japanese": "japanese",
    "korean": "korean",
    "lithuanian": "lithuanian",
    "portuguese": "Português",
    "romanian": "romanian",
    "spanish": "Espanhol",
    "turkish": "turkish"
  },
  "lists": {
    "noData": {
      "title": "Nenhum dado"
    }
  },
  "menus": {
    "admin": "Admin",
    "businessPartners": "Business Partners",
    "certificates": "Certificados",
    "communicationStudio": "Studio",
    "dashboard": "Dashboard",
    "dataTransfer": "Transferência de dados",
    "faq": "FAQ",
    "invoices": "invoices",
    "logout": "Sair",
    "products": "Produtos",
    "profile": "profile",
    "regulations": "regulations"
  },
  "showOnlyMainFabric": "showOnlyMainFabric",
  "simulation": {
    "notSubscribed": {
      "message": "message",
      "title": "title"
    }
  },
  "sort": {
    "ascending": "ascending",
    "descending": "descending",
    "search": {
      "placeholder": "placeholder"
    },
    "title": "title"
  },
  "success": {
    "message": "ação completada com sucesso",
    "title": "sucesso"
  },
  "supplier": {
    "footer": {
      "privacyPolicy": "privacyPolicy"
    },
    "menu": {
      "contacts": "Contatos",
      "documentation": "FAQ e Guia do Usuário",
      "loggedAs": "Você está logado como",
      "productionSites": "Sites de Produção",
      "requests": "Pedidos do Cliente",
      "supplierRequests": "Monitoramento de Fornecedores"
    }
  },
  "table": {
    "filter": {
      "date": {
        "preset": {
          "custom": "custom",
          "oneMonthAgo": "oneMonthAgo",
          "oneMonthFromNow": "oneMonthFromNow",
          "oneWeekAgo": "oneWeekAgo",
          "oneWeekFromNow": "oneWeekFromNow",
          "oneYearAgo": "oneYearAgo",
          "oneYearFromNow": "oneYearFromNow",
          "today": "today",
          "tomorrow": "tomorrow",
          "yesterday": "yesterday"
        }
      },
      "operator": {
        "after": "after",
        "afterOrEquals": "afterOrEquals",
        "before": "before",
        "beforeOrEquals": "beforeOrEquals",
        "between": "between",
        "empty": "empty",
        "equals": "equals",
        "isEmpty": "isEmpty",
        "isNotEmpty": "isNotEmpty",
        "notBetween": "notBetween",
        "notEmpty": "notEmpty",
        "notEquals": "notEquals"
      }
    },
    "hideColumn": "hideColumn",
    "manageColumns": "manageColumns",
    "noDataMessage": "noDataMessage",
    "noDataTitle": "noDataTitle",
    "pinColumn": "pinColumn",
    "rowsPerPage": "Linhas por página",
    "showColumn": "showColumn",
    "total": "Total: ",
    "unpinColumn": "unpinColumn",
    "views": {
      "add": {
        "error": {
          "message": "Erro ao criar a vista",
          "title": "Erro ao criar a vista"
        },
        "success": {
          "message": "Vista criada com sucesso",
          "title": "Vista criada"
        }
      },
      "delete": {
        "error": {
          "message": "Erro ao deletar a vista",
          "title": "Erro ao deletar a vista"
        },
        "modal": {
          "cancel": "Cancelar",
          "delete": "Deletar",
          "description": "Tem certeza que deseja deletar a vista {{viewName}} ? Esta ação é irreversível.",
          "title": "Confirmação"
        },
        "success": {
          "message": "Vista deletada com sucesso",
          "title": "Vista deletada"
        }
      },
      "modal": {
        "description": "Salva a vista ativa do sistema para acessá-la mais tarde. A ordenação, filtragem e configuração de colunas serão salvas.",
        "pinnedToDashboard": {
          "label": "label",
          "tooltip": "tooltip"
        },
        "reset": "Reiniciar",
        "save": "Salvar (beta)",
        "title": "Vista ativa do sistema (beta)",
        "update": "Atualizar"
      },
      "update": {
        "error": {
          "message": "Erro ao atualizar a vista",
          "title": "Erro ao atualizar a vista"
        },
        "success": {
          "message": "Vista atualizada com sucesso",
          "title": "Vista atualizada"
        }
      },
      "viewName": "Nome da vista",
      "viewNamePlaceholder": "Digite o nome da vista"
    }
  },
  "zodErrors": {
    "errorDefault": "Valor inválido",
    "invalidEmail": "Endereço de email inválido",
    "latitudeOutOfRange": "latitudeOutOfRange",
    "longitudeOutOfRange": "longitudeOutOfRange",
    "mustContainBothLatitudeAndLongitude": "mustContainBothLatitudeAndLongitude",
    "noSpecialCharacters": "O valor deve ter mais de 2 caracteres e não deve conter caracteres especiais",
    "ValueTooLong": "Valor muito longo",
    "ValueTooShort": "Valor muito curto"
  }
}
